import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { Column, Row } from "simple-flexbox";
import { StyleSheet, css } from "aphrodite";
import { withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import CheckIcon from "@material-ui/icons/Check";
import CircularProgress from "@material-ui/core/CircularProgress";
import { connect } from "react-redux";
import { reduxForm, Field, formValueSelector } from "redux-form";
import {
    renderInputWithLabel,
    renderSelectWithLabel
} from "../../components/form/FormComponent";
import { editMasterBenefit } from "../../actions/master-data/master_benefit_action";
import { getMasterBenefitEditPending, getMasterBenefitEdit, getMasterBenefitEditError } from "../../reducers/master-data/master_benefit_reducer";

class ModalEditBenefit extends Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(values) {
        let param = {
            id: this.props.formValue.id,
            name: values.name,
            total_shu: values.total_shu.match(/\d+/g).join(''),
            status: values.status.value
        }
        const callback = () => {
            this.props.handleRefresh();
            this.props.onHide();
        }
        this.props.editMasterBenefit(param, callback);
    }

    toRupiah(value) {
        if (value) {
            if (/\d+/g.test(value)) {
                const reformatted = value.match(/\d+/g).join('');
                return reformatted.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
            }
        }
    };

    render() {
        const { show,
            onHide,
            handleSubmit,
            editMasterBenefit_pending
        } = this.props;
        const statusOptions = [
            {
                label: "Aktif",
                value: 1
            },
            {
                label: "Nonaktif",
                value: 0
            }
        ]
        return (
            <Modal
                show={show}
                onHide={onHide}
                aria-labelledby="contained-modal-title-vcenter"
            >
                <Modal.Header closeButton>
                    <p style={{ fontSize: 20, fontWeight: 600 }}>Ubah Benefit</p>
                </Modal.Header>
                <Modal.Body>
                    <form
                        onSubmit={handleSubmit(this.handleSubmit)}
                        style={{ width: "100%" }}
                    >
                        <Column
                            vertical="center"
                            horizontal="stretch"
                            className={css(styles.bodyModal)}
                        >
                            <>
                                <Field
                                    name="name"
                                    placeholder="Masukkan Nama Benefit"
                                    label="Nama Benefit"
                                    component={renderInputWithLabel}
                                />
                                <Field
                                    name="total_shu"
                                    placeholder="Masukkan Jumlah SHU"
                                    label="Jumlah SHU"
                                    normalize={this.toRupiah}
                                    component={renderInputWithLabel}
                                />
                                <Field
                                    label="Status"
                                    name="status"
                                    placeholder="Pilih status"
                                    options={statusOptions}
                                    component={renderSelectWithLabel}
                                />
                            </>
                        </Column>
                        <Row
                            horizontal="flex-end"
                            vertical="center"
                            className={css(styles.footerModal)}
                        >
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                className={css(styles.approveButton)}
                                disabled={editMasterBenefit_pending}
                                startIcon={
                                    editMasterBenefit_pending ? (
                                        <CircularProgress size={14} color="secondary" />
                                    ) : (
                                            <CheckIcon />
                                        )
                                }
                            >
                                Simpan
                            </Button>
                        </Row>
                    </form>
                </Modal.Body>
            </Modal>
        )
    }
}

const styles = StyleSheet.create({
    approveButton: {
        background: "#2CB96A 0% 0% no-repeat padding-box",
        boxShadow: "none",
    },
    rejectButton: {
        background: "#EAEBED 0% 0% no-repeat padding-box",
        marginRight: 10,
        color: "#495057",
        boxShadow: "none",
    },
    footerModal: {
        backgroundColor: "#FBFBFD",
        padding: "20px 40px",
    },
    bodyModal: {
        padding: "0px 40px 20px",
        width: "100%",
    },
})

function validate(values) {
    const { name, total_shu, status } = values;
    const errors = {}
    if (!name) {
        errors.name = "Nama Benefit wajib diisi"
    }
    if (!total_shu) {
        errors.total_shu = "Jumlah SHU wajib diisi"
    }
    if (!status) {
        errors.status = "Status wajib diisi"
    }
    return errors;
}

ModalEditBenefit = reduxForm({
    form: "ModalEditBenefit",
    validate: validate,
    shouldError: () => true,
    enableReinitialize: true,
})(ModalEditBenefit)

function mapStateToProps(state) {
    const { editMasterBenefit, selectedMasterBenefit } = state;
    const selector = formValueSelector("ModalEditBenefit");
    const formValue = selector(state, "name", "total_shu", "id", "status");
    let initialValues = {};
    if (selectedMasterBenefit) {
        if (selectedMasterBenefit.isEditMasterBenefit) {
            initialValues = {
                name: selectedMasterBenefit.name,
                total_shu: selectedMasterBenefit.total_shu.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'),
                id: selectedMasterBenefit.id,
                status: {
                    label: selectedMasterBenefit.status === 0 ? "Nonaktif" : "Aktif",
                    value: selectedMasterBenefit.status
                }
            }
        }
    }
    return {
        editMasterBenefit_pending: getMasterBenefitEditPending(editMasterBenefit),
        editMasterBenefit_data: getMasterBenefitEdit(editMasterBenefit),
        editMasterBenefit_error: getMasterBenefitEditError(editMasterBenefit),
        formValue,
        initialValues
    }
}

export default connect(mapStateToProps, { editMasterBenefit })(withRouter(ModalEditBenefit));